<div class="cald_dialog">
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{ title | translate }}</h2>
  </div>

  <div class="cald_content">
    <div class="flex flex-align-center margin-bottom-10">
      <button id="rankingResetButton" type="button" class="btn btn-secondary fiori3-btn-secondary" (click)="resetRanks()">
        {{'Admin.Msg.ResetButton' | translate}}
      </button>
      <cpq-info class="cpq-info-icon" [message]="{key: 'Admin.ResetRanks.Info'}"></cpq-info>
    </div>
    <cpq-ranking [nodes]="data.nodes" [hasSearch]="true" [id]="data.id" [RankIsUnique]="data.rankIsUnique" [dynamicColumns]="data.dynamicColumns" (onRank)="updateRanks($event)"></cpq-ranking>
  </div>

  <div class="form-inline cald_dialog_buttonbar">
    <button type="button" class="btn btn-primary fiori3-btn-primary" (click)="save()">{{ 'Admin.Msg.Save'| translate }}</button>
    <button class="btn btn-tertiary fiori3-btn-tertiary" (click)="cancel()">{{'Admin.Msg.CancelButton'| translate }}</button>
  </div>
</div>
